class EventEmitter {
  constructor() {
    this.handlers = {};
  }

  on(event, handler) {
    this.handlers[event] = this.handlers[event] || [];
    this.handlers[event].push(handler);

    return this;
  }

  off(event, handler) {
    const handlers = this.handlers[event] || [];
    const handlerIndex = handlers.indexOf(handler);

    if (handlerIndex !== -1) {
      handlers.splice(handlerIndex, 1);
    }

    return this;
  }

  emit(eventName, event) {
    const handlers = this.handlers[eventName] || [];
    handlers.forEach(handler => handler(event));

    return this;
  }
}